<template>
    <div id="main">
        <div class="page">
            <alert-container :messages="msgs" />
            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t('motivo-visita') }}
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{ $t('promotor') }}</a>
                                </li>
                                <li>
                                    <a class="a-inativo">{{ $t('cadastros') }}</a>
                                </li>
                                <li>
                                    <a @click="$router.push({ name: 'visitreasons' })">{{
                                        $t('motivos-visita')
                                    }}</a>
                                </li>
                                <li>
                                    <a aria-current="page">{{
                                        !motivovisita.idmotivovisita
                                            ? $t('novo-motivo-visita')
                                            : motivovisita.descricao
                                    }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button
                            class="delete-btn"
                            type="button"
                            tag="button"
                            @click="
                                $router.push({
                                    name: 'motivo-visita-list',
                                })
                            "
                        >
                            {{ $t('voltar') }}
                        </button>
                        <button
                            v-if="(!isUpdate && permissao.create) || (isUpdate && permissao.update)"
                            class="save-btn"
                            type="button"
                            @click="salvar()"
                            :disabled="isSaving"
                        >
                            {{ $t('salvar') }}
                            <button-loader :isSaving="isSaving" />
                        </button>
                    </div>
                </div>
                <br />
                <div class="form-columns-fit page-container">
                    <div class="columns is-flex-wrap">
                        <div class="column is-2">
                            <v-input
                                :id="'codigo'"
                                ref="idmotivovisitaerp"
                                v-model="motivovisita.idmotivovisitaerp"
                                placeholder="placeholder-preencha"
                                :maxlength="30"
                                title="codigo"
                                uppercase
                            />
                        </div>
                        <div class="column is-8">
                            <v-input
                                v-model="motivovisita.descricao"
                                :id="'descricao'"
                                :placeholder="'descricao-do-motivo-visita-placeholder'"
                                :maxlength="100"
                                :title="'descricao'"
                                :msg="'msg-campo-obrigatorio'"
                                :invalid="!motivovisita.descricao"
                                ref="descricaoInput"
                                :required="true"
                            />
                        </div>
                        <div class="column is-2">
                            <label for="situacao" v-text="$t('situacao')" />
                            <v-select
                                ref="situacaoSelect"
                                :selectOnTab="true"
                                :searchable="false"
                                :options="situacoes"
                                :value="situacao"
                                @input="updateSituacao"
                                :getOptionLabel="getLabel"
                                placeholder="situacao-da-marca-placeholder"
                                class="no-clear"
                            >
                                <template slot="no-options">{{ $t('sem-resultados') }}</template>
                            </v-select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MotivoVisitaService from '@/services/promotor/MotivoVisitaService';
import MotivoVisitaValidation from '@/services/validations/MotivoVisitaValidation';
import Message from '@/models/Message';

export default {
    data() {
        return {
            motivovisita: {
                idmotivovisitaerp: null,
                situacao: 1,
            },
            editable: false,
            title: '',
            msgs: [],
            isSaving: false,
            situacao: { label: 'ativo', id: 1 },
            situacoes: [
                { label: 'ativo', id: 1 },
                { label: 'inativo', id: 0 },
            ],
            isUpdate: false,
        };
    },
    created() {
        if (this.motivovisita != null && this.motivovisita != {}) {
            this.editable = true;
        }

        this.service = new MotivoVisitaService(this.$http, this.$router);
        this.validation = new MotivoVisitaValidation(this.msgs);

        this.permissao = this.hasPermissionAccess('promotor', 'cadastros', 'visitreasons');
        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'motivos-visita' },
            });
        } else {
            this.isUpdate = this.$route.params.id ? true : false;
            if (!this.isUpdate && !this.permissao.create) {
                this.$router.push({
                    name: 'acesso-nao-permitido',
                    params: { tela: 'motivo-visita' },
                });
            }

            if (this.$route.params.id) {
                this.editable = false;
                this.carregarDados(this.$route.params.id);
            }
        }
    },
    mounted() {
        this.$refs.descricaoInput.$refs.typed.focus();
    },
    methods: {
        carregarDados(id) {
            this.service.find(id).then((body) => {
                if (body.content) {
                    this.motivovisita = body.content;
                    this.title = this.motivovisita.descricao;
                    this.situacao = this.getSituacao();
                } else {
                    this.$router.push({ name: 'new-photoreason' });
                }
            });
        },
        getLabel(option) {
            if (option.label != undefined) {
                return this.$t(option.label);
            } else {
                return this.$t(option);
            }
        },
        updateSituacao(situacao) {
            if (situacao && situacao.id != null) {
                this.motivovisita.situacao = situacao.id;
                this.situacao = situacao;
            }
        },
        getSituacao() {
            return this.situacoes.filter((s) => s.id == this.motivovisita.situacao);
        },
        salvar(redirect = this.redirectToList) {
            this.motivovisita = this.mapTosave(this.motivovisita);
            if (this.validation.validate(this.motivovisita, this.$refs)) {
                this.isSaving = true;
                this.service.save(this.motivovisita).then((body) => {
                    if (body.content) {
                        let msg = 'msg-motivovisita-salva';
                        if (this.motivovisita.id) {
                            msg = 'msg-motivovisita-editado';
                        }
                        this.motivovisita = body.content;
                        this.msgs.push(new Message('success', msg, true));
                        redirect(2);
                    } else {
                        if (this.$t(body.message)) {
                            this.msgs.push(new Message('alert', body.message, true));
                        } else {
                            this.msgs.push(
                                new Message('error', 'msg-problema-realizar-acao', true)
                            );
                        }
                    }
                    this.isSaving = false;
                });
            }
        },
        redirectToList(time) {
            setTimeout(() => {
                this.$router.push({
                    name: 'visitreasons',
                });
            }, time * 1000 + 50);
        },
        redirectToEdit(time) {
            setTimeout(() => {
                this.$router.push({
                    name: 'edit-visitreason',
                    params: { id: this.motivovisita.idmotivovisita },
                });
            }, time * 1000 + 50);
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;

    .page {
        position: relative;
    }
}
</style>
